import { DATA_KEY_TO_COLLECTION } from './collections';

/** Collections readable without auth (must match `firestore.rules` public reads). */
export const PUBLIC_DATA_KEYS = [
  'jobs',
  'portfolio',
  'websiteServices',
  'websiteNews',
  'websitePartners',
];

const ORDERED_DATA_KEYS = Object.keys(DATA_KEY_TO_COLLECTION);

/** `firestore.rules`: read allowed for any signed-in user. */
const SIGNED_IN_READ_KEYS = [
  'projects',
  'employees',
  'clients',
  'meetings',
  'attendance',
  'tasks',
  'leaveRequests',
  'notifications',
];

/** `firestore.rules`: invoices / quotations read. */
const FINANCE_READ_ROLES = ['super_admin', 'finance', 'admin'];

/** `firestore.rules`: applicants read. */
const HR_APPLICANTS_ROLES = ['super_admin', 'hr'];
const CONTACT_READ_ROLES = ['super_admin', 'admin', 'hr'];
const DOCUMENT_READ_ROLES = ['super_admin', 'finance', 'hr', 'admin'];

/**
 * Which AppContext data keys to sync for the current user.
 * Must stay aligned with `firestore.rules` or listeners get permission-denied.
 */
export function getSubscribedDataKeysForUser(user) {
  if (!user) {
    return ORDERED_DATA_KEYS.filter((k) => PUBLIC_DATA_KEYS.includes(k));
  }

  const role = user.role || 'employee';
  const allowed = new Set(PUBLIC_DATA_KEYS);
  SIGNED_IN_READ_KEYS.forEach((k) => allowed.add(k));

  if (FINANCE_READ_ROLES.includes(role)) {
    allowed.add('invoices');
    allowed.add('quotations');
  }
  if (HR_APPLICANTS_ROLES.includes(role)) {
    allowed.add('applicants');
  }
  if (CONTACT_READ_ROLES.includes(role)) {
    allowed.add('contacts');
  }
  if (DOCUMENT_READ_ROLES.includes(role)) {
    allowed.add('documents');
  }
  if (role === 'super_admin') {
    allowed.add('approvalRequests');
  }

  return ORDERED_DATA_KEYS.filter((k) => allowed.has(k));
}
